import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "diamonds-search-form-simple" }
const _hoisted_2 = { class: "filter-row border-b border-gray-200 py-4 last:border-b-0" }
const _hoisted_3 = { class: "mt-2 overflow-x-auto no-scrollbar scroll-smooth" }
const _hoisted_4 = {
  key: 2,
  class: "mt-6 overflow-x-auto no-scrollbar scroll-smooth"
}
const _hoisted_5 = { class: "flex gap-8 pb-4 px-2 h-32" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]

import { computed } from "vue";
import DiamondsSearchFormIcons from "@/components/diamonds/form/diamondsSearchFormIcons.vue";
import DiamondsSearchFormNumberRange from "@/components/diamonds/form/diamondsSearchFormNumberRange.vue";
import DiamondsSearchFormRange from "@/components/diamonds/form/diamondsSearchFormRange.vue";
import DiamondsSearchFormSwitch from "@/components/diamonds/form/diamondsSearchFormSwitch.vue";
import DiamondsSearchFormList from "@/components/diamonds/form/diamondsSearchFormList.vue";
import DiamondsSearchFormPresets from "@/components/diamonds/form/diamondsSearchFormPresets.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormSimple',
  props: {
    filters: {},
    activeFilters: {},
    simpleFilterKeys: { default: () => ['type', 'size', 'form'] },
    getFilterLabel: {},
    getActiveValueLabel: {},
    isFilterDefined: {},
    presets: { default: () => [] }
  },
  emits: ["updateFilter", "updateFilters"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visibleFilterKeys = computed(() => {
  return props.simpleFilterKeys
    .filter(key => props.filters[key])
    .sort((a, b) => (props.filters[a].order || 0) - (props.filters[b].order || 0));
});

const updateFilter = (key: string, val: any) => {
  emit('updateFilter', key, val);
}

const sizeSteps = [0.3, 0.4, 0.5, 0.7, 1.0, 1.5, 2.0, 2.5, 3.0];
const filteredSizeSteps = computed(() => {
  const min = props.filters.size?.min ?? 0;
  const max = props.filters.size?.max ?? 10;
  return sizeSteps.filter(s => s >= min && s <= max);
});

const getDiamondImageUrl = (form: string) => {
  const formFilter = props.filters['form'];
  if (!formFilter || !formFilter.image) return "";
  const processedVal = formFilter.lowercaseImage !== false ? form.toLowerCase() : form;
  return formFilter.image.replace("{value}", processedVal);
};

const activeForm = computed(() => {
  return props.activeFilters['form'] || props.filters['form']?.default || 'BR';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFilterKeys.value, (key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (__props.filters[key].type === 'icon' && __props.filters[key].view === 'list')
              ? (_openBlock(), _createBlock(DiamondsSearchFormIcons, {
                  key: 0,
                  filter: __props.filters[key],
                  "active-value": __props.activeFilters[key],
                  onUpdate: (val) => updateFilter(key, val)
                }, null, 8, ["filter", "active-value", "onUpdate"]))
              : (__props.filters[key].type === 'number' && __props.filters[key].view === 'range' && key !== 'size')
                ? (_openBlock(), _createBlock(DiamondsSearchFormNumberRange, {
                    key: 1,
                    filter: __props.filters[key],
                    "active-value": __props.activeFilters[key],
                    onUpdate: (val) => updateFilter(key, val)
                  }, null, 8, ["filter", "active-value", "onUpdate"]))
                : (key === 'size')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSizeSteps.value, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s,
                            class: "flex flex-col justify-center items-center cursor-pointer min-w-fit",
                            onClick: ($event: any) => (updateFilter(key, {min: s, max: s}))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-16 h-16 overflow-hidden rounded-full flex items-center justify-center mb-2 transition-all duration-300 relative bg-white", __props.activeFilters[key] && __props.activeFilters[key].min === s && __props.activeFilters[key].max === s
                      ? 'shadow-md w-20 h-20'
                      : ''])
                            }, [
                              _createElementVNode("div", {
                                class: "transition-transform duration-500 ease-out",
                                style: _normalizeStyle({ transform: `scale(${0.4 + (s / 3) * 0.6})` })
                              }, [
                                _createElementVNode("img", {
                                  src: getDiamondImageUrl(activeForm.value),
                                  alt: activeForm.value,
                                  class: "w-18 h-18 object-contain opacity-80"
                                }, null, 8, _hoisted_7)
                              ], 4)
                            ], 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-sm text-gray-500 tracking-wide whitespace-nowrap transition-all duration-300", __props.activeFilters[key] && __props.activeFilters[key].min === s && __props.activeFilters[key].max === s ? 'font-bold' : ''])
                            }, _toDisplayString(s.toLocaleString('de-DE', { minimumFractionDigits: 1 })) + " ct. ", 3)
                          ], 8, _hoisted_6))
                        }), 128))
                      ])
                    ]))
                  : ((__props.filters[key].type === 'icon' || __props.filters[key].type === 'text') && __props.filters[key].view === 'range')
                    ? (_openBlock(), _createBlock(DiamondsSearchFormRange, {
                        key: 3,
                        filter: __props.filters[key],
                        "active-value": __props.activeFilters[key],
                        onUpdate: (val) => updateFilter(key, val)
                      }, null, 8, ["filter", "active-value", "onUpdate"]))
                    : ((__props.filters[key].type === 'text' || __props.filters[key].type === 'bool') && __props.filters[key].view === 'switch')
                      ? (_openBlock(), _createBlock(DiamondsSearchFormSwitch, {
                          key: 4,
                          filter: __props.filters[key],
                          "active-value": __props.activeFilters[key],
                          onUpdate: (val) => updateFilter(key, val)
                        }, null, 8, ["filter", "active-value", "onUpdate"]))
                      : (__props.filters[key].type === 'text' && __props.filters[key].view === 'list')
                        ? (_openBlock(), _createBlock(DiamondsSearchFormList, {
                            key: 5,
                            filter: __props.filters[key],
                            "active-value": __props.activeFilters[key],
                            onUpdate: (val) => updateFilter(key, val)
                          }, null, 8, ["filter", "active-value", "onUpdate"]))
                        : _createCommentVNode("", true)
          ])
        ]),
        (key === 'type' && __props.presets && __props.presets.length > 0)
          ? (_openBlock(), _createBlock(DiamondsSearchFormPresets, {
              key: 0,
              presets: __props.presets,
              "active-filters": __props.activeFilters,
              class: "mb-6 mt-2",
              onUpdateFilters: _cache[0] || (_cache[0] = (val) => emit('updateFilters', val))
            }, null, 8, ["presets", "active-filters"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})